import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE = process.env.SERVER_URL || "";
const SOURCES = new Set(["disbursement", "physical_financial", "combined"]);

export const updateCashFlowPlanningSource = async (projectId, source) => {
  if (!projectId || !SOURCES.has(source)) return null;
  const { token } = cookies.get("userId") || {};
  try {
    const response = await fetch(
      `${BASE}/project/${encodeURIComponent(projectId)}/cashFlowPlanningSource`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ source }),
      },
    );
    if (!response.ok) return null;
    return await response.json();
  } catch {
    return null;
  }
};
